import React, { useEffect, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { useSelector } from "react-redux";
import ChipsDataTable from "./ChipsDetail/ChipsDataTable";
import DataTable from "react-data-table-component";

export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

const SceneList = ({ userId ,selectedPremise}: ChipsControlProps) => {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [isReload, setReload] = useState<boolean>(false);

  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const columns = [
    {
      name: "Name",
      selector: (row: any) => (row?.name ? row.name : "-"),
      sortable: true,
    },
    {
      name: "Favourite",
      selector: (row: any) => (row?.isFav ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_SCENE_LIST}`}
        title="Scene List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        expandableRows={true}
        ExpandedComponent={ExpandedComponent}
        ExpandCollapseIcon={ExpandCollapseIcon}
        idName={"Scenelist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        userId={userId}
        selectedPremise={selectedPremise}
      />
    </div>
  );
};

export default SceneList;
export const ExpandedComponent = ({ data }: { data: any }) => {
  const switchColumns: any[] = [
    {
      name: "Device Type",
      selector: (row: any) => row.label,
      sortable: false,
    },
    {
      name: "Count",
      selector: (row: any) => row.count,
      sortable: false,
    },
  ];

  // Create table rows including static counts
  const SceneData = [
    {
      label: "Switches",
      count: data.switches?.length || 0,
      data: data.switches,
    },
    {
      label: "Remotes",
      count: data.remotes?.length || 0,
      data: data.remotes,
    },
    {
      label: "Assigned Scene Panel",
      count: data.assigned_scene_panel?.length || 0,
      data: data.assigned_scene_panel,
    },
  ];

  return (
    <div className="p-2">
      <DataTable
        columns={switchColumns}
        data={SceneData}
        dense
        highlightOnHover
        noDataComponent="No remotes available"
        customStyles={customStyles}
        expandableRows={true}
        expandableRowsComponent={ExpandedComponentSecond}
        expandableIcon={{
          collapsed: <ExpandCollapseIcon expanded={false} />,
          expanded: <ExpandCollapseIcon expanded={true} />,
        }}
      />
    </div>
  );
};

export const ExpandedComponentSecond = ({ data }: { data: any }) => {
  let columns: any[] = [];

  if (data?.label === "Switches") {
    columns = [
      {
        name: "Slave",
        selector: (row: any) => row.slave || "-",
        sortable: true,
      },
      {
        name: "Display Name",
        selector: (row: any) => row.displayName || "-",
        sortable: true,
      },
      {
        name: "Button",
        selector: (row: any) => row.button || "-",
        sortable: true,
      },
      {
        name: "On/Off",
        selector: (row: any) => (row.isOn ? "true" : "false"),
        cell: (row: any) =>
          row.isOn === true ? (
            <span className="font-size-11 badge-soft-success badge bg-secondary">
              true
            </span>
          ) : (
            <span className="font-size-11 badge-soft-danger badge bg-secondary">
              false
            </span>
          ),
        sortable: true,
      },
      {
        name: "Dimmer Value",
        selector: (row: any) => row.dimmerValue || "-",
        sortable: true,
      },
    ];
  } else if (data?.label === "Remotes") {
    columns = [
      {
        name: "Slave",
        selector: (row: any) => row.slave || "-",
        sortable: true,
      },
      {
        name: "Type",
        selector: (row: any) => row.type || "-",
        sortable: true,
      },
      {
        name: "On/Off",
        selector: (row: any) => (row.isOn ? "true" : "false"),
        cell: (row: any) =>
          row.isOn === true ? (
            <span className="font-size-11 badge-soft-success badge bg-secondary">
              true
            </span>
          ) : (
            <span className="font-size-11 badge-soft-danger badge bg-secondary">
              false
            </span>
          ),
        sortable: true,
      },
      {
        name: "	Brand Name",
        selector: (row: any) => row.brandName || "-",
        sortable: true,
      },

      {
        name: "Brand Model",
        selector: (row: any) => row.brandModal || "-",
        sortable: true,
      },
    ];
  } else if (data?.label === "Assigned Scene Panel") {
    console.log("data: ", data);
    // Define columns for Assigned Scene Panel if needed
    columns = [
      {
        name: "Slave",
        selector: (row: any) => row.slave || "-",
        sortable: true,
      },
      {
        name: "Button",
        selector: (row: any) => row.button || "-",
        sortable: true,
      },
    ];
  }

  return (
    <div className="p-2">
      <DataTable
        columns={columns}
        data={data?.data || []}
        dense
        highlightOnHover
        noDataComponent="No switches available"
        customStyles={customStyles}
      />
    </div>
  );
};
export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
